import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Observable } from 'rxjs';
import { QuestionService } from 'src/app/common/question-dialog/question-dialog.service';
import { DataBagService } from '../data-bag.service';
import { Data2Service } from '../data2.service';
import { DateService } from '../date.service';
import { InfoboxService } from '../infobox/infobox.service';
import { LoaderService } from '../loader/loader.service';
import { LockerService } from '../locker.service';
import { UuidService } from '../uuid.service';

@Component({
	selector: 'app-show',
	template: '',
})
export class ShowComponent implements OnInit, OnDestroy {
	pageFunction = '';
	pageTitle = 'Dodawanie';
	editable = false;
	data;
	errors;
	protected itemsBeforeDataLoad = 0;
	protected parentComponent = '';
	protected apiUrl = '';
	protected apiUrlAdd = '';
	protected questionSubscription;
	protected idType = 'char'; // char/auto
	protected apiType = 'erp';
	private readonly touristGuidesPage: string = 'tourist-guides-calendar';

	constructor(
		protected api: Data2Service,
		protected bag: DataBagService,
		protected uuid: UuidService,
		protected date: DateService,
		protected infobox: InfoboxService,
		protected question: QuestionService,
		protected loader: LoaderService,
		protected locker: LockerService,
		protected route: ActivatedRoute,
		protected router: Router,
	) {}

	@HostListener('window:beforeunload') canDeactivate(): Observable<boolean> | boolean {
		return !this.editable;
	}

	ngOnInit(): void {
		if (!this.route.snapshot.params['id']) {
			this.router.navigate([this.parentComponent]);
		}
		if (this.route.snapshot.params['id'] === 'add') {
			this.pageFunction = 'add';
			this.editable = true;
			if (!this.apiUrlAdd) {
				this.apiUrlAdd = '/' + this.parentComponent + '/';
			}
		} else {
			this.pageFunction = 'edit';
			this.data.id = this.route.snapshot.params['id'];
			this.apiUrl = this.getApiUrl();
		}
		this.loader.show();
		this.loadBefore();
	}

	ngOnDestroy(): void {
		if (this.questionSubscription) {
			this.questionSubscription.unsubscribe();
		}
		this.ngOnDestroyOther();
	}

	ngOnDestroyOther(): void {}

	deleteAsk(): void {
		this.question.ask('Czy na pewno usunąć?', 'deleteAsk');
		this.questionSubscription = this.question.status.subscribe((result) => {
			if (result.dialogId !== 'deleteAsk') {
				return;
			}
			if (!result.result) {
				return;
			}
			this.doDel();
		});
	}

	editUnlock(): void {
		this.editable = true;
		this.locker.lock('test', 123);
	}

	submit(): void {
		this.loader.show();
		this.submitBefore();
		let hasErrors = false;
		for (const key in this.errors) {
			if (!this.data[key]) {
				this.errors[key] = true;
				hasErrors = true;
				continue;
			}
			this.errors[key] = false;
		}
		if (hasErrors) {
			this.loader.hide();
			return;
		}
		switch (this.pageFunction) {
			case 'add':
				this.doAdd();
				break;
			case 'edit':
				this.doEdit();
				break;
		}
	}

	protected getApiUrl(): string {
		return '/' + this.parentComponent + '/' + this.data.id;
	}

	protected loadBefore(): void {
		this.loadData();
	}

	protected loadData(): void {
		if (this.pageFunction !== 'edit') {
			this.afterLoadData();
			this.loader.hide();
			return;
		}
		this.itemsBeforeDataLoad--;
		if (this.itemsBeforeDataLoad > 0) {
			return;
		}
		this.loader.show();
		this.doGet();
	}

	protected convertData(data): any {
		return data;
	}

	protected afterLoadData(): void {}

	protected afterLoadDataGet(): void {
		this.afterLoadData();
	}

	protected pageTitleGenerate(): string {
		return '';
	}

	protected submitAfter(): void {}

	protected submitBefore(): void {}

	protected doGet(): void {
		switch (this.apiType) {
			case 'erp':
				this.api.get(this.apiUrl, (result, error) => {
					if (error) {
						this.loader.hide();
						return;
					}
					this.data = this.convertData(result.data);
					this.afterLoadDataGet();
					this.loader.hide();
					this.pageTitle = this.pageTitleGenerate();
				});
				break;
			case 'bag':
				this.bag.get(this.apiUrl, (result, error) => {
					if (error) {
						this.loader.hide();
						return;
					}
					this.data = this.convertData(result);
					this.afterLoadDataGet();
					this.loader.hide();
					this.pageTitle = this.pageTitleGenerate();
				});
				break;
		}
	}

	protected doAdd(): void {
		switch (this.apiType) {
			case 'erp':
				if (this.idType === 'char') {
					this.data.id = this.uuid.generate();
				}
				this.api.post(this.apiUrlAdd, this.submitConvert(this.data), (result, error) => {
					if (this.idType === 'auto') {
						this.data.id = result.data;
					}
					this.afterSend(result, error);
				});
				break;
			case 'bag':
				this.bag.post(this.apiUrlAdd, this.submitConvert(this.data), (result, error) => {
					this.data.id = result.id;
					this.afterSend(result, error);
				});
				break;
		}
	}

	protected doEdit(): void {
		switch (this.apiType) {
			case 'erp':
				this.api.put(this.apiUrl, this.submitConvert(this.data), (result, error) => {
					this.afterSend(result, error);
				});
				break;
			case 'bag':
				this.bag.put(this.apiUrl, this.submitConvert(this.data), (result, error) => {
					this.afterSend(result, error);
				});
				break;
		}
	}

	protected afterSend(result, error): void {
		this.loader.hide();
		if (error) {
			return;
		}
		if (this.parentComponent === this.touristGuidesPage) {
			this.router.navigate([this.parentComponent]);
		} else {
			this.router.navigate([this.parentComponent, this.data.id]);
		}
		this.pageFunction = 'edit';
		this.editable = false;
		this.pageTitle = this.pageTitleGenerate();
		this.apiUrl = this.getApiUrl();
		this.infobox.success('Zapisano');
		this.submitAfter();
	}

	protected submitConvert(data): any {
		return data;
	}

	private doDel(): void {
		switch (this.apiType) {
			case 'erp':
				this.api.del(this.apiUrl, (result, error) => {
					if (error) {
						return;
					}
					this.router.navigate([this.parentComponent]);
				});
				break;
			case 'bag':
				this.bag.del(this.apiUrl, (result, error) => {
					if (error) {
						return;
					}
					this.router.navigate([this.parentComponent]);
				});
				break;
		}
	}
}
